export interface Plugin {
  id: string;
  slug: string;
  name: string;
  tagline: string;
  description: string;
  category: string;
  icon: string;
  iconImage?: string;
  color: string;
  heroImage: string;
  demoVideoUrl: string;
  features: string[];
  benefits: string[];
  useCases: string[];
  technologies: string[];
  pricing: {
    free?: boolean;
    price?: string;
    license?: string;
  };
  gallery: string[];
  downloads?: number;
  rating?: number;
  testimonial?: {
    quote: string;
    author: string;
    position: string;
    company: string;
  };
}

export const plugins: Plugin[] = [
  {
    id: '1',
    slug: 'activity-monitor-pro',
    name: 'Activity Monitor Pro',
    tagline: 'Complete WordPress Activity Tracking & Undo System',
    description: 'Never lose track of what happens on your WordPress site. Activity Monitor Pro logs every change, lets you undo mistakes instantly, and detects suspicious behavior with AI-powered anomaly detection. From content changes to user actions—everything is tracked, searchable, and reversible.',
    category: 'Security/Monitoring/Compliance',
    icon: 'Activity',
    iconImage: '/lovable-uploads/activity-monitor-pro-icon.jpg',
    color: 'from-green-500 to-emerald-600',
    heroImage: '/lovable-uploads/activity-monitor-pro-hero.png',
    demoVideoUrl: 'https://www.youtube.com/embed/nxleB6rqJ8s',
    features: [
      'Track 450+ WordPress activities (posts, pages, media, users, settings, plugins)',
      'One-click undo system for posts, pages, and settings',
      'AI-powered anomaly detection for suspicious behavior',
      'Real-time activity dashboard with live updates',
      'Advanced filtering and search across all logs',
      'Restore points & snapshots for rollback',
      'Multi-channel notifications (Slack, Discord, Email, Microsoft Teams)',
      'Custom scheduled reports (daily, weekly, monthly)',
      'Export logs in CSV, PDF, and JSON formats',
      'Unlimited activity retention (premium)',
      'GDPR-compliant data handling'
    ],
    benefits: [
      'Undo accidental deletions in seconds—no backups needed',
      'Catch security breaches before they become disasters',
      'Full accountability trail for multi-author sites',
      'Debug plugin conflicts with detailed change logs',
      'Recover from "who changed what" emergencies instantly',
      'Compliance-ready audit trails for enterprise clients',
      'Sleep better knowing every change is tracked and reversible'
    ],
    useCases: [
      'Agency sites with multiple editors and contributors',
      'E-commerce stores tracking inventory and order changes',
      'Membership sites monitoring user activity',
      'Corporate sites requiring compliance audit trails',
      'Development teams debugging production issues',
      'Content-heavy sites with frequent publishing workflows'
    ],
    technologies: ['WordPress Activity API', 'Machine Learning', 'Real-time WebSockets', 'Slack API', 'Discord Webhooks', 'Microsoft Teams Integration'],
    pricing: {
      free: false,
      price: 'From $211/year',
      license: 'Premium Enterprise license. Includes unlimited retention, AI detection, and advanced features.'
    },
    gallery: [
      '/lovable-uploads/activity-monitor-dashboard.png',
      '/lovable-uploads/activity-monitor-log.png',
      '/lovable-uploads/activity-monitor-settings.png'
    ],
    downloads: 3456,
    rating: 4.9,
    testimonial: {
      quote: "Activity Monitor Pro saved us when a rogue editor accidentally deleted 50 product pages. One click and everything was back. The AI anomaly detection also caught a compromised user account trying to inject malicious code. Absolute lifesaver for our agency.",
      author: "Marcus Thompson",
      position: "CTO",
      company: "Digital Nexus Agency"
    }
  }
];
